import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Search from 'components/Search'

import { screenSize } from 'styles/shared'

const CustomerSearch = () => {
  const [query, setQuery] = useState('')

  const navigate = useNavigate()

  return (
    <S.Search
      focusOnMount
      value={query}
      placeholder="Search Customer"
      ariaLabel="search customers"
      onChange={setQuery}
      onSearch={(query) => navigate(`/customers?q=${query}`)}
      onClickClearIcon={() => setQuery('')}
    />
  )
}

export default CustomerSearch

const S = {
  Search: styled(Search)`
    max-width: 500px;
    flex-grow: 1;
    margin-right: -25px;

    @media ${screenSize.small} {
      margin-right: 0;
    }
  `
}
